export default __webpack_public_path__ + "static/media/Beppe4.164132c9.jpg";